export const NO_VALUE = 'NO_VALUE';
export const FALSE_VALUE = 'false';
export const TRUE_VALUE = 'true';

export enum FEATURE_FLAG {
  ADOBE_ANALYTICS_DISABLED = 'ADOBE_ANALYTICS_DISABLED',
  IS_SITE_DOWN_FOR_MAINTENANCE = 'IS_SITE_DOWN_FOR_MAINTENANCE',
  EXAMPLE_FEATURE_FLAG = 'EXAMPLE_FEATURE_FLAG',
  ENABLE_SELF_STUDY_NAVIGATION_TABS = 'ENABLE_SELF_STUDY_NAVIGATION_TABS',
  ENABLE_SELF_STUDY_ASSESSMENT_CREATOR_REDIRECT = 'ENABLE_SELF_STUDY_ASSESSMENT_CREATOR_REDIRECT',
  ENABLE_V2_AUTHESS_APP_LINKING = 'ENABLE_V2_AUTHESS_APP_LINKING',
  IS_NCLEX_SELF_STUDY_OPTION_ENABLED = 'IS_NCLEX_SELF_STUDY_OPTION_ENABLED',
  ENABLE_STUDENT_PERFORMANCE_DETAILS = 'ENABLE_STUDENT_PERFORMANCE_DETAILS',
  EAQ_ASSESSMENT_PLAYER_REDIRECT = 'EAQ_ASSESSMENT_PLAYER_REDIRECT',
  ENABLE_NEW_PLAYER_EVOLVE_DIRECT_ACCESS = 'ENABLE_NEW_PLAYER_EVOLVE_DIRECT_ACCESS',
  ENABLE_EAQ_LINKABLE_PAGE_SHERPATH = 'ENABLE_EAQ_LINKABLE_PAGE_SHERPATH',
  ENABLE_CREATE_QUIZ_PAGE = 'ENABLE_CREATE_QUIZ_PAGE',
}

export const AB_TEST = 'AB_TEST';

export const AB_TEST_CONFIG_MAP: Partial<Record<FEATURE_FLAG, string[]>> = {
  [FEATURE_FLAG.EXAMPLE_FEATURE_FLAG]: [
    'EXAMPLE_FLAVOR_1',
    'EXAMPLE_FLAVOR_2',
  ],
};
